module.exports = __webpack_public_path__ + "media/images/smiley_1-cbfb26f2392297793d1e6d962ac60b56.svg";